export default __webpack_public_path__ + "1058c8275b052c0cd4a6772007175f27.png";